<template>
  <v-card flat class="pa-4">
    <h3 class="text-h6 mb-4">📥 Importar Excel de Existencias</h3>

    <!-- Selector de archivo -->
    <v-file-input
      v-model="archivo"
      label="Selecciona archivo Excel"
      accept=".xlsx, .xls"
      prepend-icon="mdi-file-excel"
      outlined
      dense
      class="mb-4"
    />

    <!-- Botón para enviar -->
    <v-btn
      :disabled="!archivo || cargando"
      color="primary"
      @click="subirArchivo"
    >
      <v-icon left>mdi-upload</v-icon>
      {{ cargando ? 'Subiendo...' : 'Importar Excel' }}
    </v-btn>

    <!-- Mensaje de éxito -->
    <v-alert
      v-if="resultado"
      type="success"
      class="mt-4"
      dense
      text
    >
      ✅ {{ resultado }}
    </v-alert>

    <!-- Mensaje de error -->
    <v-alert
      v-if="errores"
      type="error"
      class="mt-4"
      dense
      text
    >
      ❌ {{ errores }}
    </v-alert>

    <!-- Lista de cambios -->
    <v-list v-if="cambios.length" dense class="mt-4">
      <v-list-item v-for="(cambio, index) in cambios" :key="index">
        <v-list-item-content>
          <span>
            • SKU <strong>{{ cambio.sku }}</strong> – Almacén <strong>{{ cambio.lugar }}</strong> → {{ cambio.accion }}
          </span>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ImportadorExistenciaView',
  data() {
    return {
      archivo: null,
      cargando: false,
      resultado: '',
      errores: '',
      cambios: [],
    };
  },
  methods: {
    async subirArchivo() {
      if (!this.archivo) return;

      this.cargando = true;
      this.resultado = '';
      this.errores = '';
      this.cambios = [];

      const formData = new FormData();
      formData.append('archivo', this.archivo);

      try {
        const token = localStorage.getItem('token');
        const response = await axios.post('https://mvexpress.mx/api/importar-stock-excel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        });

        this.resultado = response.data.message || 'Archivo procesado.';
        this.cambios = response.data.cambios || [];
      } catch (error) {
        this.errores = error.response?.data?.error || 'Error al subir el archivo.';
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>
